import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { NgxSmartModalService } from 'ngx-smart-modal';

@Component({
  standalone: false,
  selector: 'finxone-platform-workflow-reset-widget-config-rhs-dialog',
  templateUrl: './reset-widget-config-rhs-dialog.component.html',
  styleUrls: ['./reset-widget-config-rhs-dialog.component.scss'],
})
export class WorkflowResetWidgetDialogComponent {
  private ngxSmartModalService = inject(NgxSmartModalService);

  @Input() title: string;

  @Output() updateResetWidget = new EventEmitter<{
    isReset: boolean;
    uniqueId: string;
  }>();

  modalCls = 'reset-widget-dialog';

  modalStyle = {
    height: '400px',
    maxHeight: '250px',
    maxWidth: '35vw',
  };

  resetWidgetConfig(): void {
    const data = this.ngxSmartModalService.getModalData(
      'resetWidgetConfigDialog',
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ) as any;

    this.updateResetWidget.emit({ ...data, isReset: true });
  }

  closeAlert(): void {
    this.ngxSmartModalService.get('resetWidgetConfigDialog').close();
  }
}
